import PropTypes from 'prop-types';
import React from 'react';

import { avatarColor, formatNumber, initial } from '../utils';
import StatusPill from './StatusPill';

const STATS = [
  { label: 'Spotify', key: 'spotify' },
  { label: 'Facebook', key: 'facebook' },
  { label: 'Avg cap', key: 'avg_cap' },
];

const ArtistCard = ({ row }) => (
  <a href={row.path} className="ab-card">
    <div className="ab-card__top">
      {row.image_thumb_url ? (
        <img className="ab-avatar" src={row.image_thumb_url} alt="" />
      ) : (
        <span className="ab-avatar" style={{ background: avatarColor(row.name) }}>{initial(row.name)}</span>
      )}
      <div className="ab-card__id">
        <span className="ab-card__name">{row.name}</span>
        <span className="ab-card__sub">{[row.genre, row.agency].filter(Boolean).join(' · ') || '—'}</span>
      </div>
      <StatusPill onTour={row.on_tour} />
    </div>
    <div className="ab-card__stats">
      {STATS.map(({ label, key }) => (
        <div className="ab-card__stat" key={key}>
          <span className="ab-card__stat-label">{label}</span>
          <span className="ab-card__stat-value">{formatNumber(row[key])}</span>
        </div>
      ))}
    </div>
  </a>
);
ArtistCard.propTypes = { row: PropTypes.object.isRequired };

export default ArtistCard;
